import type { FC, ReactNode } from 'react'
import type { ArticleSummary } from '@/types'

import MainContainer from '@/components/generals/main-container'
import EditorialGrid from '@/components/generals/editorial-grid'
import SectionHeading from '@/components/generals/section-heading'
import ArticleListItem from '@/components/journal/article-list-item'

interface LatestJournalProps {
    articles: Array<ArticleSummary>
}

/** Lead story plus two shorter entries, set asymmetrically like a front page. */
const LatestJournal: FC<LatestJournalProps> = ({ articles }): ReactNode => {
    const [lead, ...rest] = articles

    if (!lead) return null

    return (
        <MainContainer as='section' id='journal' aria-labelledby='journal-title' className='py-24 md:py-36'>
            <SectionHeading
                id='journal-title'
                index='03'
                label='Latest journal'
                title={<>Notes from the <em className='text-brand'>workbench</em>.</>}
                description='Tutorials, field notes and essays on engineering, infrastructure and AI, with the commands and code included.'
                action={{ href: '/journal', label: 'All articles' }}
            />

            <EditorialGrid className='mt-12 gap-y-4 md:mt-16'>
                <div className='col-span-4 md:col-span-12 lg:col-span-7'>
                    <ArticleListItem article={lead} variant='feature' />
                </div>

                <div className='col-span-4 mt-8 md:col-span-12 lg:col-span-4 lg:col-start-9 lg:mt-0'>
                    {rest.map((article) => (
                        <ArticleListItem key={article.slug} article={article} variant='compact' />
                    ))}
                </div>
            </EditorialGrid>
        </MainContainer>
    )
}

export default LatestJournal
